// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ListView: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 21"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="none"
                fillRule="evenodd"
                stroke="currentColor"
                d="M7.51 2.415h20.943M1.283 3.547H4.68V1.283H1.283zm6.227 7.217h20.943m-27.17 1.132H4.68V9.632H1.283zM7.51 18.83h20.943m-27.17 1.132H4.68v-2.264H1.283z"
            />
        </svg>
    );
};

export default React.memo(ListView);
